import { FIREBASE_AUTH_ERRORS } from './errors';

export function getFirebaseAuthErrorMessage(code: string) {
  const message = code ? FIREBASE_AUTH_ERRORS[code as keyof typeof FIREBASE_AUTH_ERRORS] : null;

  return message ?? 'An unknown error occurred. Please try again or contact support.';
}
